// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"0444831a","48":"c6ee04ba","136":"9f95e044","160":"1c1f25c1","177":"ebce4e48","237":"3533f4aa","486":"fe9b6b54","527":"3150bf7b","753":"fa760a41","787":"7984f105","820":"2016873b","835":"46de9af0","980":"ad1e7396"}[chunkId] + ".chunk.js";
};